// fields which will use a date input and must be converted
// to a date filter on the target list page interface
export const CENTERED_COLS = {
    type: true,
    populationSize: true,
}
